import { useEffect, useState } from "react";
import usePagination from "../../usePagination";
import { fetchCoursesOfGroup } from "../../../service/UserService/groupService";
import { message } from "antd";

export const useGroupHistoryCourse = (id) => {
    const [groupCourseData, setGroupCourseData] = useState([]);
    const [courseLoading, setCourseLoading] = useState(false);
    const {
    currentPage,
    pageSize,
    setTotal,
    paginationConfig,
    handlePageChange,
    setCurrentPage,
  } = usePagination(0, 10);



      const getGroupData = async () => {
    setCourseLoading(true);

    const params = {
      page: currentPage,
      size: pageSize,
    };

    const response = await fetchCoursesOfGroup(id, params);

    if (response.success) {
      setGroupCourseData(response?.data?.content || []);
      setTotal(response?.data?.totalElements || 0);
    } else {
      message.error(response.message);
    }

    setCourseLoading(false);
  };

    useEffect(() => {
    getGroupData();
  }, [currentPage, pageSize]);



  return {
    groupCourseData,
    courseLoading,
    paginationConfig,
    handlePageChange,
    getGroupData,
  }
}